import { useThreadPreviewReadOnly } from '@/features/chat/threadPreviewReadOnly'
import { buildAssistantMessageActionProps } from './buildAssistantMessageActionProps'
import AssistantMessageContentViewShell from './AssistantMessageContentViewShell'
import { useAssistantMessageContentHandlers } from './useAssistantMessageContentHandlers'
import { useAssistantMessageContentModel } from './useAssistantMessageContentModel'

export default function AssistantMessageContentView(props) {
  const readOnly = useThreadPreviewReadOnly()
  const {
    children,
    text = '',
    refinementSourceText = text,
    showActions = true,
    alwaysShowActions = false,
    revealKey,
    onTryAgain,
    onThinkLonger,
    onSearchWeb,
    onNotes,
    onMenu,
    onReadAloud,
    onGood,
    onBad,
  } = props
  const vm = useAssistantMessageContentModel(text)
  const handlers = useAssistantMessageContentHandlers(vm, { onMenu, onNotes, onReadAloud, onGood, onBad, text })

  return (
    <AssistantMessageContentViewShell
      revealKey={revealKey}
      refinementSourceText={refinementSourceText}
      showActions={showActions && !readOnly}
      alwaysShowActions={alwaysShowActions && !readOnly}
      actionProps={buildAssistantMessageActionProps(props, vm, handlers)}
      vm={vm}
      handlers={handlers}
      menuProps={{ onTryAgain, onThinkLonger, onSearchWeb, text }}
    >
      {children}
    </AssistantMessageContentViewShell>
  )
}
